// Export a single shared store instance for the whole app
import createStore from './store';

const sharedStore = createStore();

export default sharedStore;

